import { ClientProfile, CoachProfile, UserRole } from "@joonapp/web-shared"

import { CoachingGroup, CoachingSubscriptionInfo } from "../../types"
import { isNewClient } from "../../util/coachingGroups"
import { createJoonAPIClient } from "../../util/joon-api"

export const getCoachingGroups = async () => {
  const API = createJoonAPIClient()
  return API.get<{ results: CoachingGroup[] }>("/api/coaching-groups/", {
    params: { role: UserRole.COACH },
  }).then((response) =>
    response.data.results.sort(
      (a, b) =>
        Number(isNewClient(b.date_created)) -
        Number(isNewClient(a.date_created))
    )
  )
}

export const getCoachingSubscription = async (userId: number) => {
  const API = createJoonAPIClient()
  return API.get<CoachingSubscriptionInfo>(
    "/api/coaching-groups/subscription/",
    {
      params: { user_id: userId },
    }
  ).then((response) => response.data)
}

export const getDeactivatedCoachingGroups = async () => {
  const API = createJoonAPIClient()
  return API.get<{
    results: (CoachingGroup & {
      deactivated_profiles: (CoachProfile | ClientProfile)[]
      change_coach: boolean
      date_deactivated: string | null
    })[]
  }>("/api/coaching-groups/", {
    params: { role: UserRole.COACH, deactivated: true },
  }).then((response) => response.data.results)
}

export const getCoachDirectReports = async () => {
  const API = createJoonAPIClient()
  return API.get<{
    results: {
      coach_profile: CoachProfile
      group_ids: number[]
    }[]
  }>("/api/coaching-groups/direct-reports/").then(
    (response) => response.data.results
  )
}
